const defaultState = {
  profiles: []
};
export default (state = defaultState, action) => {
  switch (action.type) {
    case 'SET_PROFILES':
      return {
        ...state,
        profiles: action.profiles
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/rootReducer.jsx